/* eslint-disable no-multi-str */
import React from "react"
import SectionContainer from "../components/SectionContainer"
import SkillViewBuilder from "./SkillViewBuilder"

import nodeLogo from "../images/nodelogo.png"
import expressLogo from "../images/expresslogo.png"
import jestLogo from "../images/jestlogo.png"
import webpackLogo from "../images/webpacklogo.png"
import mysqlLogo from "../images/mysqllogo.png"
import mongoLogo from "../images/mongologo.png"
import redisLogo from "../images/redislogo.png"

const skills = [
  {
    name: "Nodejs",
    icon: nodeLogo,
    proficiency: "Proficient",
    description: "JavaScript beyond the browser",
    customtext: "My go-to choice for building small web servers quickly. \
                Also allows unit testing of JavaScript code using testing \
                frameworks. These days I use Deno for easier integration \
                with TypeScript.",
    related: [
      {
        name: "Express",
        icon: expressLogo,
        proficiency: "Proficient",
      },
      {
        name: "Jest",
        icon: jestLogo,
        proficiency: "Proficient",
      },
      {
        name: "Webpack",
        icon: webpackLogo,
        proficiency: "Familiar",
      },
    ]
  },
  {
    name: "MySQL",
    icon: mysqlLogo,
    proficiency: "Proficient",
    description: "Industry-standard Relational Database",
    customtext: "My preferred choice for building reliable and scalable databases.",
  },
  {
    name: "MongoDB",
    icon: mongoLogo,
    proficiency: "Familiar",
    description: "Popular, document-based, NoSQL database system",
    customtext: "I use mongo for quick prototypes and small scale projects. \
                Easy interop with JavaScript makes for seamless integration.",
  },
  {
    name: "Redis",
    icon: redisLogo,
    proficiency: "Familiar",
    description: "In-memory, NoSQL database with support for data structures",
    customtext: "I've used Redis a couple of times in small personal projects.",
  },
]


const ServerSkills = () => (
  <SectionContainer header="Servers & Databases">
    <SkillViewBuilder skills={skills}/>
  </SectionContainer>
)

export default ServerSkills